import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class EgFooter extends Component {
    render() {
        return (
            <div >
                <a href='' onClick={onUnsubClick} target="_blank">الغاء الاشتراك</a>
            </div>
        );
    }
}

export default EgFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/egfooter.js